import { useQuery } from "@tanstack/react-query";
import { ObjectQueriesTags } from "../../api/object";
import { GetObjectResponse } from "../../api/object/types";
import { getObject } from "../api/get-object";

interface IUseGetObject {
  objectId: string;
  enabled?: boolean;
}

export function useObject({ objectId, enabled = true }: IUseGetObject) {
  const query = useQuery({
    queryFn: () => getObject({ objectId }),
    queryKey: ObjectQueriesTags.getObject({ objectId }),
    enabled,
  });
  return {
    ...query,
    data: query.data as GetObjectResponse,
  };
}
